import { HttpClient } from '@angular/common/http'
import { Inject, Injectable } from '@angular/core'
import { UnespCoreEnvironment, UnespCoreGenericService } from '@unesp/core'
import { Observable } from 'rxjs'
import { RegistroAcademico } from './registro-academico'

@Injectable({
  providedIn: 'root',
})
export class RegistroAcademicoService extends UnespCoreGenericService {
  readonly ROUTE = 'shared/registro-academico'
  client!: HttpClient

  constructor(
    http: HttpClient,
    @Inject('environment') protected environment: UnespCoreEnvironment
  ) {
    super(http, environment)
    this.client = http
  }

  ras(perfil: string): Observable<RegistroAcademico[]> {
    return this.fetchWithoutPagination(`${this.ROUTE}/${perfil}`)
  }

  log(perfil: string, nome: string) {
    return this.create(`${this.ROUTE}/${perfil}`, nome)
  }
}
